import "./SidebarCategory.scss";
import {
  AssessmentButton,
  AssessmentCheckboxRadio,
  InputField,
  RightSidePanel,
  showToast,
  SkeletonList,
  TemplateSearch,
} from "ui-components";
import { useTranslation } from "react-i18next";
import SkillCard from "../../../../components/SkillCard/SkillCard";
import { useEffect, useRef, useState } from "react";
import {
  createSupportTicket,
  getAllSupportType,
  getAssessmentDetailsByAssessementId,
  getDefaultSkill,
  getIndustrySkillMapping,
  getSkillDetails,
  getSkillKeywords,
} from "../../../../service/Scope/Scope";
import useDebounce from "../../../../utils/Hooks/useDebounce";
import { setSessionStorageItem } from "../../../../utils/SessionStorageMethod/setSessionStorageItem";
import { getSessionStorageItem } from "../../../../utils/SessionStorageMethod/getSessionStorageItem";
import {
  calculatTotalTimeOfSkill,
  capitalizeFirstLetter,
  checkUniqueIdMatch,
  drafteditedformData,
  editedformData,
  getElementWidth,
  getScreenWidth,
  groupBySkillId,
  handleScroll,
  modifyKeywordsDataOnEdit,
  processData,
  removeDuplicateBySkillID,
  removeDuplicatesBySkillId,
  removeFromQueryParams,
  setInQueryParams,
} from "../../../../utils/Common/Constant";
import SetDraftJsonInSession from "../../AssessmentDraftJson/SetDraftJsonInSession";
import { checkKeysInSessionStorage } from "../../../../utils/Common/checkKeysInSessionStorage";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import DownArrow from "../../../../utils/Images/DownArrow";
import { removeSessionStorageItem } from "../../../../utils/SessionStorageMethod/removeSessionStorageItem";
import { getCreateAssessmentDraftJson } from "../../../../service/DraftJson/DraftJson";
import PreviousArrow from "../../../../utils/Images/PreviousArrow";
import NextArrow from "../../../../utils/Images/NextArrow";
import TestCaseWrongIcon from "../../../../utils/Images/TestCaseWrongIcon";
import DownArrowIcon from "../../../../utils/Images/DownArrowIcon";
import UpArrowIcon from "../../../../utils/Images/UpArrowIcon";
import SearchSuggestion from "../../../../components/SearchSuggestion/SearchSuggestion";
import CircleCrossIcon from "../../../../utils/Images/CircleCrossIcon";
import Loader from "../../../../components/Loader/Loader";
import AddIcon from "../../../../utils/Images/AddIcon";
import { getSkillsForLevels } from "../../../../service/CvScanning/CvScanning";

const areAllExistingDataInUpdateSkill = (
  storedSkills: any,
  existingPreviewData: any,
) => {
  return existingPreviewData.some((existingItem: any) =>
    storedSkills.some((updatedItem: any) => updatedItem.id === existingItem.id),
  );
};

// click on added skill then it will invoke
export const handlePopupOpen = async (
  skillId: string,
  skillItemData: any,
  setIsAddedSKillPopupOpen: any,
  setSelectedLevel?: any,
  navigate?: any,
  queryParams?: any,
) => {
  const getSKillRes = await getSkillDetails(skillId);
  getSKillRes.id = skillItemData?.id;
  if (
    skillItemData?.selectedDifficultyLevels &&
    Object.keys(skillItemData.selectedDifficultyLevels).length > 0
  ) {
    getSKillRes.selectedDifficultyLevels =
      skillItemData.selectedDifficultyLevels;
  } else {
    getSKillRes.selectedDifficultyLevels = {};
  }
  const order = ["Beginner", "Intermediate", "Expert"];
  const sortedDifficultyLevels = getSKillRes?.difficultyLevels
    ?.split(",")
    ?.sort((a: any, b: any) => order.indexOf(a) - order.indexOf(b))
    ?.join(",");
  getSKillRes.difficultyLevels = sortedDifficultyLevels;
  setSelectedLevel(getSKillRes?.selectedDifficultyLevels);
  if (getSKillRes?.skillId) {
    setInQueryParams(queryParams, "skillSideBar", "true", navigate);
    setInQueryParams(queryParams, "skId", skillId, navigate);
    setIsAddedSKillPopupOpen({
      isPopupOpen: true,
      popupData: getSKillRes,
    });
  }
};

const SidebarCategory = ({ jobSkillData, jobTitle }: any) => {
  const { t } = useTranslation();
  const editedParams = new URLSearchParams(location.search).get("edited");
  const userId = localStorage.getItem("companyId") ?? "";
  const { tempUniqueId } = useParams();
  const { pathname } = useLocation();
  const tempUniqueIdBySession = localStorage.getItem("tempUniqueId") ?? null;
  const [category, setCategory] = useState(
    getSessionStorageItem("category") ?? [],
  );
  const [selectedCategory, setSelectedCategory] = useState<any>(
    getSessionStorageItem("selectedCategory") ?? [],
  );
  const [selectedFilter, setSelectedFilter] = useState<any>(
    getSessionStorageItem("selectedFilter") ?? [],
  );
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const searchGlobalSkill = useDebounce(globalSearch.trim(), 700);
  const [skill, setSkill] = useState<any>(
    getSessionStorageItem("ownPreview") || [],
  );
  const [addedSkills, setAddedSkills] = useState<any>(
    getSessionStorageItem("ownPreview") ?? [],
  );
  const queryParams = new URLSearchParams(location.search);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const skillSideBar = searchParams.get("skillSideBar") == "true" || false;
  const skId = searchParams.get("skId") || "";
  const [isAddedSKillPopupOpen, setIsAddedSKillPopupOpen] = useState<any>({
    isPopupOpen: false,
    popupData: {},
  });
  const [selectedLevel, setSelectedLevel] = useState({});
  const [requestNewSkillPopup, setRequestNewSkillPopup] = useState(false);
  const selectedSkillRef = useRef(null);
  const scrollAddedSkillRef = useRef(null);
  const [questionTypeCategory, setQuestionTypeCategory] = useState(
    getSessionStorageItem("questionTypeCategory") ?? [
      { id: 1, selected: false, questionType: "Video", skillCount: "0" },
      { id: 2, selected: false, questionType: "MCQ", skillCount: "0" },
      { id: 3, selected: false, questionType: "Coding", skillCount: "0" },
      { id: 4, selected: false, questionType: "Essay", skillCount: "0" },
    ],
  );
  const [isSameSkillAdded, setIsSameSkillAdded] = useState(false);
  const [isFirstEffectDone, setIsFirstEffectDone] = useState(false);
  const [requestSkillInput, setRequestSkillInput] = useState("");
  const [requestKeywordInput, setRequestKeywordInput] = useState("");
  const [requestNewItemLoading, setRequestNewItemLoading] = useState({
    skillLoadig: false,
    keywordLoading: false,
  });
  const [searchKeywordTerm, setSearchKeywordTerm] = useState("");
  const searchKeywordTermDebounce = useDebounce(searchKeywordTerm.trim(), 300);
  const [keywordSuggestions, setKeywordSuggestions] = useState<any>([]);
  const [addedKeywordsList, setAddedKeywordsList] = useState<any>([]);
  const keywordsPageSize = 50;
  const [keywordsCurrentPage, setKeywordsCurrentPage] = useState(1);
  const keywordsListRef = useRef<HTMLDivElement | null>(null);
  const [keywordDownLoader, setKeywordDownLoader] = useState(false);
  const onKeywordEndReached = () => {
    if (!keywordsListRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = keywordsListRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setKeywordDownLoader(true);
      setKeywordsCurrentPage(keywordsCurrentPage + 1);
    }
  };
  useEffect(() => {
    if (keywordsCurrentPage < Math.ceil(keywordsCount / keywordsPageSize)) {
      const keywordsListDiv = keywordsListRef.current;
      if (keywordsListDiv) {
        keywordsListDiv.addEventListener("scroll", onKeywordEndReached);
      }
      return () => {
        if (keywordsListDiv) {
          keywordsListDiv.removeEventListener("scroll", onKeywordEndReached);
        }
      };
    }
  }, [keywordSuggestions]);
  const [loadingSuggestions, setLoadingSuggestions] = useState<boolean>(true);
  const [keywordsCount, setKeywordsCount] = useState(0);
  const skillCardRef = useRef<any>(null);
  const [requestNewKeyword, setRequestNewKeyword] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Tracks if there are more items to load
  const [currentPage, setCurrentPage] = useState(1); // Tracks the current page number
  const [categoryCurrentPage, setCategoryCurrentPage] = useState(1); // Tracks the current page number
  const [isCategoryOrDefault, setIsCategoryDefault] = useState("default");
  const itemsPerPage = 30; // Number of items to fetch per page
  const categoryPageSize = 30; // Number of items to fetch per page
  const searchSuggestionRef = useRef<any>(null);
  const [skillCardLoader, setSkillCardLoader] = useState(false);
  const [sortBy, setSortBy] = useState<
    Record<string, { label: string; sort: "ASC" | "DESC" | null }>
  >({
    usage: { label: "Usage", sort: "DESC" },
    aToZ: { label: "A-Z", sort: null },
  });
  const [selectedSortBy, setSelectedSortBy] = useState<any>({
    label: "usage",
    sort: "DESC",
  });
  const [isRefreshed, setIsRefreshed] = useState<any>(false);
  // First useEffect
  useEffect(() => {
    const isKeyPresent = checkKeysInSessionStorage(
      [
        "ownPreview",
        "Type",
        "titleHeadContent",
        "existingPreview",
        "existingData",
      ],
      "any",
    );

    if (
      (!isKeyPresent && !editedParams) ||
      checkUniqueIdMatch(tempUniqueId, tempUniqueIdBySession)
    ) {
      // API call to set store value in session
      SetDraftJsonInSession(userId, tempUniqueId, pathname).then(() => {
        setIsFirstEffectDone(true); // Set flag after API call completes
        setSkillCardLoader(true);
        if (jobSkillData?.length) {
          setAddedSkills(processData(jobSkillData));
          setSessionStorageItem("ownPreview", processData(jobSkillData));
          setSessionStorageItem("titleHeadContent", jobTitle);
          setSkillCardLoader(false);
        }
      });
    } else {
      setIsFirstEffectDone(true); // Set flag if condition doesn"t trigger API call
    }
  }, []);
  // edit assessment work flow
  useEffect(() => {
    (async () => {
      if (editedParams) {
        setSkillCardLoader(true);
        const draftRes = await getCreateAssessmentDraftJson(
          userId,
          tempUniqueId,
        );
        if (
          (Object.keys(draftRes?.data?.data).length > 0 &&
            draftRes?.data?.data?.createAssessmentJson?.build?.assessmentSkill
              ?.length) ||
          draftRes?.data?.data?.createAssessmentJson?.isStoreEditedData
        ) {
          if (
            draftRes?.data?.data?.createAssessmentJson?.build?.assessmentSkill
              ?.length
          ) {
            setSkill(
              draftRes?.data?.data?.createAssessmentJson?.build
                ?.assessmentSkill,
            );
            setAddedSkills(
              draftRes?.data?.data?.createAssessmentJson?.build
                ?.assessmentSkill,
            );
            setSkillCardLoader(false);
          }

          drafteditedformData(draftRes?.data?.data);
        } else {
          setSkillCardLoader(true);
          const editedData = await getAssessmentDetailsByAssessementId(
            tempUniqueId ?? "",
          );
          const skills = editedData?.data?.assessmentSkills?.map(
            (item: any) => {
              return {
                ...item,
                id: item.id ?? Math.random(),
                questionNo: item?.questionNo ?? item?.totalQuestions,
              };
            },
          );
          const updateSkill = await groupBySkillId(skills);
          setSkill(updateSkill);
          setAddedSkills(updateSkill);
          setSessionStorageItem("ownPreview", updateSkill);
          editedformData(editedData);
          setSkillCardLoader(false);
        }
      }
    })();
  }, []);

  useEffect(() => {
    industrySkillMapping();
  }, []);
  useEffect(() => {
    // If no skills remain, set the default skill
    if (addedSkills.length === 0) {
      setHasMore(true);
      setCurrentPage(1);
    }
  }, [addedSkills]);

  useEffect(() => {
    industrySkillMapping(true, selectedCategory, globalSearch, selectedFilter);
  }, [
    selectedCategory,
    selectedFilter,
    searchGlobalSkill,
    currentPage,
    categoryCurrentPage,
    selectedSortBy?.sort,
    selectedSortBy?.label,
    addedSkills,
  ]);
  // Second useEffect, dependent on isFirstEffectDone
  useEffect(() => {
    const fetchSkills = async () => {
      if (isFirstEffectDone) {
        const storedSkills = getSessionStorageItem("ownPreview") ?? [];
        const existingPreviewData =
          getSessionStorageItem("existingPreview")?.subjectFieldSet ?? [];
        if (storedSkills?.length > 0 || existingPreviewData?.length > 0) {
          let updateSkill = [];
          const result = areAllExistingDataInUpdateSkill(
            storedSkills,
            existingPreviewData,
          );
          if (result) {
            updateSkill = [...storedSkills];
          } else {
            updateSkill = [...storedSkills, ...existingPreviewData];
          }
          const uniqueSkillMap = new Map();
          updateSkill.forEach((item: any) => {
            const skillItem = {
              ...item,
              skillName: item?.title ?? item?.skillName,
              skillIcon: item?.icon ?? item?.skillIcon,
              skillLevel: item?.difficultyLevel,
              type: "template",
            };

            uniqueSkillMap.set(item?.id, skillItem);
          });
          const updateSkillData = Array.from(uniqueSkillMap.values());
          const extractedSkillIds = updateSkillData
            .map((item: any) => item?.skillId)
            .filter((id: string | null | undefined) => id != null);
          const skillIdsArray = JSON.stringify(extractedSkillIds);
          const getSkillsLevel = await getSkillsForLevels([skillIdsArray]);
          //this is new code to match the difficulty levels present in db by calling api and show available difficulty level which is even not selected
          const seenSkillIds = new Set();
          const updatedArrayWithAllLevels = updateSkillData.reduce(
            (acc: any[], item: any) => {
              if (seenSkillIds.has(item.skillId)) return acc; // skip duplicates
              seenSkillIds.add(item.skillId);
              const matchedSkill = getSkillsLevel?.data?.data?.find(
                (u: any) => u.skillId === item.skillId,
              );
              if (matchedSkill) {
                const levels = matchedSkill.difficultyLevels.split(",");
                const oldSelected = item.selectedDifficultyLevels || {};
                const selectedDifficultyLevels = levels.reduce(
                  (obj: any, level: string) => {
                    obj[level] = oldSelected[level] || 0;
                    return obj;
                  },
                  {},
                );
                acc.push({
                  ...item,
                  difficultyLevel: matchedSkill.difficultyLevels,
                  difficultyLevels: matchedSkill.difficultyLevels,
                  selectedDifficultyLevels,
                });
              } else {
                acc.push(item); // If no match found, keep original
              }
              return acc;
            },
            [],
          );
          // Update session and state
          setSessionStorageItem(
            "ownPreview",
            processData(updatedArrayWithAllLevels),
          );
          setAddedSkills(processData(updatedArrayWithAllLevels));
        }
      }
    };
    fetchSkills();
  }, [isFirstEffectDone]);
  const [width, setWidth] = useState(getScreenWidth());
  const [elementWidth, setElementWidth] = useState(0);
  useEffect(() => {
    if (selectedSkillRef.current) {
      setElementWidth(getElementWidth(selectedSkillRef.current));
    }
    const handleResize = () => {
      if (selectedSkillRef.current) {
        setElementWidth(getElementWidth(selectedSkillRef.current));
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [addedSkills]);

  useEffect(() => {
    const handleResize = () => setWidth(getScreenWidth());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [addedSkills]);

  const industrySkillMapping = async (
    isFitered: boolean = false,
    categorylist: any = [],
    search: string = "",
    filter: any = [],
  ) => {
    setSkillCardLoader(true);
    const resSkillmapping = await getIndustrySkillMapping(
      categorylist,
      search,
      categoryCurrentPage,
      categoryPageSize,
      filter,
      selectedSortBy?.label,
      selectedSortBy?.sort,
    );
    const defaultSkillRes = await getDefaultSkill(
      localStorage.getItem("industryId") ?? "",
      search,
      search?.length ? 1 : currentPage,
      itemsPerPage,
      filter,
      selectedSortBy?.label,
      selectedSortBy?.sort,
    );
    if (
      defaultSkillRes?.data.length < itemsPerPage ||
      resSkillmapping?.data?.skillList?.data?.length < categoryPageSize
    ) {
      setHasMore(false); // No more items to load
    } else {
      if (selectedCategory?.length === 0) {
        setIsCategoryDefault("default");
      } else {
        setIsCategoryDefault("category");
      }
      setHasMore(true);
    }
    const defaultUpdateSkill = (defaultSkillRes?.data ?? [])?.map(
      (item: any, ind: number) => {
        return {
          ...item,
          difficultyLevel: item?.difficultyLevels?.split(","),
          id: Math.random() + ind,
        };
      },
    );
    setSessionStorageItem("defaultSkill", processData(defaultUpdateSkill));
    if (resSkillmapping?.status === 200) {
      const categoryList = resSkillmapping?.data?.categoryList.map(
        (item: any, ind: number) => {
          return {
            id: ind,
            selected: false,
            categoryName: item?.categoryName,
            skillsCategoryId: item?.skillsCategoryId,
            skillCount: item?.totalSkill,
          };
        },
      );
      if (resSkillmapping?.data?.questionTypeSkill) {
        setQuestionTypeCategory((prev: any) =>
          prev.map((item: any) => {
            const matched = resSkillmapping.data.questionTypeSkill.find(
              (q: any) => q.questionType === item.questionType,
            );
            return {
              ...item,
              skillCount: matched ? matched.skillCount : "0",
            };
          }),
        );
      }
      let withCategoryList: any;
      let withOutCategoryList: any;
      if (isFitered) {
        if (categorylist?.length) {
          withCategoryList = (resSkillmapping?.data?.skillList?.data ?? []).map(
            (item: any, ind: number) => {
              const existingSkill = addedSkills.find(
                (ele: any) => ele.skillId === item.skillId,
              );

              if (existingSkill) {
                return existingSkill;
              } else {
                return {
                  ...item,
                  difficultyLevel: item?.difficultyLevels?.split(","),
                  id: Math.random() + ind,
                };
              }
            },
          );
        } else {
          withOutCategoryList = (defaultSkillRes?.data ?? []).map(
            (item: any, ind: number) => {
              const existingSkill = addedSkills.find(
                (ele: any) => ele.skillId === item.skillId,
              );

              if (existingSkill) {
                return existingSkill;
              } else {
                return {
                  ...item,
                  difficultyLevel: item?.difficultyLevels?.split(","),
                  id: Math.random() + ind,
                };
              }
            },
          );
        }

        if (categorylist?.length) {
          const ownPreview = getSessionStorageItem("ownPreview");
          const isOwnPreviewValid = ownPreview?.length;
          const isUpdateSkillValid = withCategoryList?.length;

          const finalskill = isOwnPreviewValid
            ? (setIsSameSkillAdded(true), ownPreview)
            : isUpdateSkillValid
              ? processData(withCategoryList)
              : processData(defaultUpdateSkill);

          const shouldUseUpdateSkill =
            categorylist?.length ||
            search?.length ||
            (categorylist?.length && filter?.length);
          setSkillCardLoader(true);
          // resolve bug by change this code
          setSkill((prevSkills: any) => {
            const updatedSkills = shouldUseUpdateSkill
              ? processData(removeDuplicateBySkillID(withCategoryList))
              : finalskill;
            const mergedSkills = [...prevSkills, ...updatedSkills];
            const uniqueMergedSkills = removeDuplicateBySkillID(mergedSkills);

            setSkillCardLoader(false);
            return uniqueMergedSkills;
          });
          // added to save list of cards when category select
        } else {
          if (!categorylist?.length && !filter?.length && !search?.length) {
            setSkillCardLoader(true);
            setSkill((prevSkills: any) => {
              // Ensure prevSkills is an array
              const validPrevSkills = Array.isArray(prevSkills)
                ? prevSkills?.length
                  ? prevSkills
                  : getSessionStorageItem("ownPreview") || []
                : [];
              // Fetch stored preview only if skill is empty and addedSkills has no entries
              const storedPreview = getSessionStorageItem("ownPreview") || [];
              if (
                getSessionStorageItem("ownPreview")?.length > 0 &&
                !isRefreshed
              ) {
                setHasMore(false);
              }
              // Determine the new skills to add
              const newSkills =
                storedPreview.length && !isRefreshed
                  ? storedPreview
                  : processData(defaultUpdateSkill);
              // Merge and remove duplicates (based on `id`)
              return removeDuplicatesBySkillId([
                ...addedSkills,
                ...validPrevSkills,
                ...newSkills,
              ]);
            });
            setSkillCardLoader(false);
          } else {
            setSkillCardLoader(true);
            setSkill(processData(withOutCategoryList));
            setSkillCardLoader(false);
            removeSessionStorageItem("defaultSkill");
          }
        }
      } else {
        setCategory(categoryList);
      }
    } else {
      setSkillCardLoader(false);
    }
  };
  const [existingSkillsSuggestions, setExistingSkillsSuggestions] =
    useState<any>([]);
  const [showSkillsSuggestion, setShowSkillsSuggestions] = useState(false);
  const debounceExistingSkillsSuggestions = useDebounce(
    requestSkillInput.trim(),
    500,
  );
  const getExistingSkillsSuggestions = async () => {
    try {
      const res = await getDefaultSkill(
        localStorage.getItem("industryId") ?? "",
        requestSkillInput.trim(),
        1,
        itemsPerPage,
        [],
        "usage",
        "DESC",
      );

      const uniqueExistingSkills = Object.values(
        res?.data.reduce((acc: any, skill: any) => {
          const key = skill.skillName.toLowerCase();
          if (!acc[key]) {
            acc[key] = skill;
          }
          return acc;
        }, {}),
      );
      setExistingSkillsSuggestions(uniqueExistingSkills);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (requestSkillInput) {
      getExistingSkillsSuggestions();
    }
  }, [debounceExistingSkillsSuggestions]);
  // sort by function
  const handleSortBy = (key: string) => {
    if (key === "Usage") {
      setSortBy({
        usage: {
          label: "Usage",
          sort: sortBy?.usage.sort === "ASC" ? "DESC" : "ASC",
        },
        aToZ: { label: "A-Z", sort: null },
      });
      setSelectedSortBy({
        label: "usage",
        sort: sortBy?.usage.sort === "ASC" ? "DESC" : "ASC",
      });
    } else {
      setSortBy({
        usage: {
          label: "Usage",
          sort: null,
        },
        aToZ: {
          label: "A-Z",
          sort: sortBy?.aToZ.sort === "ASC" ? "DESC" : "ASC",
        },
      });
      setSelectedSortBy({
        label: "name",
        sort: sortBy?.aToZ.sort === "ASC" ? "DESC" : "ASC",
      });
    }
    setSkillCardLoader(true);
    setSkill([]);
    setCurrentPage(1);
    setCategoryCurrentPage(1);
    setHasMore(true);
  };

  // category type
  const handleCheckboxChange = (id: any) => {
    setCurrentPage(1);
    setCategoryCurrentPage(1);
    setHasMore(true);
    setIsRefreshed(true);
    setSkillCardLoader(true);
    setSkill([]);
    setCategory((prevState: any) => {
      const updatedCategory = prevState?.map((item: any) => {
        if (item?.id === id) {
          return { ...item, selected: !item?.selected };
        }
        return item;
      });

      const newSelectedCategory = updatedCategory
        .filter((item: any) => item?.selected)
        .map((item: any) => item?.skillsCategoryId);
      if (newSelectedCategory?.length === 0) {
        setIsCategoryDefault("default");
      } else {
        setIsCategoryDefault("category");
      }
      setSelectedCategory(newSelectedCategory);
      return updatedCategory;
    });
  };
  useEffect(() => {
    if (skillSideBar && skId) {
      handlePopupOpen(
        skId,
        skill,
        setIsAddedSKillPopupOpen,
        setSelectedLevel,
        navigate,
        queryParams,
      );
    }
  }, []);
  // question type function
  const handlequestionTypeChange = (id: any) => {
    setSkillCardLoader(true);
    setSkill([]);
    setQuestionTypeCategory((prevState: any) => {
      const updatedQuestionTypeCategory = prevState?.map((item: any) => {
        if (item?.id === id) {
          return { ...item, selected: !item?.selected };
        }
        return item;
      });
      // Update selectedFilter based on the new question type category state
      const newSelectedFilter = updatedQuestionTypeCategory
        .filter((item: any) => item?.selected)
        .map((item: any) => item?.questionType);
      setSelectedFilter(newSelectedFilter);
      return updatedQuestionTypeCategory;
    });
    setSkillCardLoader(false);
  };
  // add skill
  const handleAddSkill = (skill: any) => {
    // Remove entries with a value of 0
    skill.selectedDifficultyLevels = Object.fromEntries(
      Object.entries(skill.selectedDifficultyLevels).filter(
        ([, value]) => value !== 0,
      ),
    );
    const questionNo = skill?.selectedDifficultyLevels
      ? Object.values(skill?.selectedDifficultyLevels).reduce(
          (acc: any, value: any) => acc + value,
          0,
        )
      : skill?.totalQuestions;
    skill.questionNo = questionNo;
    setAddedKeywordsList([]);
    handlePopupOpen(
      skill?.skillId,
      skill,
      setIsAddedSKillPopupOpen,
      setSelectedLevel,
      navigate,
      queryParams,
    );
    setIsRefreshed(true);
  };
  // edit added skill
  const handleAddedSkill = (UpdateSkill: any) => {
    UpdateSkill.selectedDifficultyLevels = Object.fromEntries(
      Object.entries(UpdateSkill.selectedDifficultyLevels).filter(
        ([, value]) => {
          return value !== 0;
        },
      ),
    );
    const questionNo = UpdateSkill?.selectedDifficultyLevels
      ? Object.values(UpdateSkill?.selectedDifficultyLevels).reduce(
          (acc: any, value: any) => acc + value,
          0,
        )
      : UpdateSkill?.totalQuestions;
    UpdateSkill.questionNo = questionNo;
    if (questionNo) {
      setSkillCardLoader(true);
      setKeywordsCurrentPage(1);
      setLoadingSuggestions(true);
      setAddedSkills((prevState: any) => {
        const skillExists = prevState.some(
          (ele: any) => ele?.skillId === UpdateSkill?.skillId,
        );
        let updatedSkills;
        if (skillExists) {
          updatedSkills = prevState.map((ele: any) => {
            if (ele?.skillId === UpdateSkill?.skillId) {
              return UpdateSkill;
            }
            return ele;
          });
        } else {
          updatedSkills = [...prevState, UpdateSkill];
        }

        // Store the updated skills array in session storage
        setSessionStorageItem("ownPreview", updatedSkills);
        setSkill(updatedSkills);
        setIsAddedSKillPopupOpen({ isPopupOpen: false, popupData: {} });
        return updatedSkills;
      });
      setSkillCardLoader(false);
    } else {
      showToast(t("CREATE_ASSESSMENT.NUMBER_OF_QUESTION"));
    }
  };
  // remove add skill
  const handleRemoveSkill = (uniqueId: number) => {
    setGlobalSearch("");
    setAddedSkills((prev: any) => {
      const updatedSkills = prev?.filter((ele: any) => ele?.id !== uniqueId);
      // Store the updated skills array in session storage
      if (isSameSkillAdded) {
        setSkill(updatedSkills);
      }
      const existingPreviewData =
        getSessionStorageItem("existingPreview")?.subjectFieldSet ?? [];
      const existingKillExist = areAllExistingDataInUpdateSkill(
        updatedSkills,
        existingPreviewData,
      );
      if (!existingKillExist) {
        removeSessionStorageItem("existingPreview");
        removeSessionStorageItem("existingData");
      }
      setSessionStorageItem("ownPreview", updatedSkills);
      setSkill(updatedSkills);
      return updatedSkills;
    });
    handleReset();
  };
  // reset category or filter
  const handleReset = () => {
    setCategory((prevState: any) => {
      const updatedCategory = prevState?.map((item: any) => {
        return { ...item, selected: false };
      });
      const newSelectedCategory = updatedCategory
        .filter((item: any) => item?.selected)
        .map((item: any) => item?.skillsCategoryId);
      setSelectedCategory(newSelectedCategory);
      return updatedCategory;
    });
    setQuestionTypeCategory((prevState: any) => {
      const updatedCategory = prevState?.map((item: any) => {
        return { ...item, selected: false };
      });
      const newSelectedFilter = updatedCategory
        .filter((item: any) => item?.selected)
        .map((item: any) => item?.questionType);
      setSelectedFilter(newSelectedFilter);
      return updatedCategory;
    });
    setGlobalSearch("");
    setSkill([]);
    setCurrentPage(1);
    setCategoryCurrentPage(1);
  };
  // get keywords api
  const getSkillKeywordsApi = async (
    skillId: any,
    levels: any,
    value?: any,
  ) => {
    for (const key in levels) {
      if (levels[key] === 0) {
        delete levels[key];
      }
    }
    const difficultyLevelArray = ["Beginner", "Intermediate", "Expert"];
    try {
      // setLoadingSuggestions(true);
      const res = await getSkillKeywords(
        skillId,
        difficultyLevelArray,
        value?.trim() ?? "",
        value?.trim() ? 100 : keywordsPageSize,
        value?.trim() ? 1 : keywordsCurrentPage,
      );
      if (res?.status === 200) {
        const prevSessionKeywords =
          getSessionStorageItem("unfilterdSkillKeywords") || [];
        const newSessionKeywords = res?.data?.data || [];
        // Append new data to old data in session when load more
        const updatedSessionKeywords = [
          ...prevSessionKeywords,
          ...newSessionKeywords,
        ];
        setSessionStorageItem("unfilterdSkillKeywords", updatedSessionKeywords);
        setKeywordsCount(res?.data?.totalCount);
        const uniqueMap = new Map<
          string,
          { skillId: string; keywords: string; level: string[] }
        >();

        res?.data?.data?.forEach((item: any) => {
          const keywordsArray = item.keywords
            .split(",")
            .map((kw: any) => kw.trim().toLowerCase());

          keywordsArray.forEach((keyword: any) => {
            if (uniqueMap.has(keyword)) {
              const existingEntry = uniqueMap.get(keyword)!;
              if (!existingEntry.level.includes(item.level)) {
                existingEntry.level.push(item.level);
              }
            } else {
              uniqueMap.set(keyword, {
                skillId: item.skillId,
                keywords: keyword,
                level: [item.level],
              });
            }
          });
        });

        const result = Array.from(uniqueMap.values());
        const sortedSkills = result.sort((a, b) =>
          a.keywords.localeCompare(b.keywords),
        );
        if (value?.trim()) {
          setKeywordSuggestions(() => {
            const newSuggestions = sortedSkills.filter((skill) =>
              skill.keywords.includes(value.trim().toLowerCase()),
            );

            return newSuggestions;
          });
        } else {
          setKeywordSuggestions((prevSuggestions: any[]) => {
            const newSuggestions = sortedSkills.filter((skill) =>
              skill.keywords.includes(value.trim().toLowerCase()),
            );

            // Filter out duplicates based on `keywords`
            const updatedSuggestions = [
              ...prevSuggestions,
              ...newSuggestions.filter(
                (newSkill) =>
                  !prevSuggestions.some(
                    (prevSkill) => prevSkill.keywords === newSkill.keywords,
                  ),
              ),
            ];

            return updatedSuggestions;
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingSuggestions(false);
      setKeywordDownLoader(false);
    }
  };
  const onAddSuggestionClick = (skillObj: any) => {
    setAddedKeywordsList([...addedKeywordsList, ...skillObj]);
  };
  // remove added keyword
  const handleDeleteAddedKeyword = (keyword: any) => {
    const updatedKeywordsList = addedKeywordsList?.filter(
      (item: any) => item?.keywords !== keyword,
    );
    setAddedKeywordsList(updatedKeywordsList);
  };
  // Function to handle the "Load More" button click
  const loadMore = () => {
    if (isCategoryOrDefault === "default") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
    } else {
      const nextPage = categoryCurrentPage + 1;
      setCategoryCurrentPage(nextPage);
    }
  };

  // handle save button functionality
  const handleSaveBtnClick = () => {
    const isInvalidLevel = addedKeywordsList?.some((item: any) => {
      // Check if at least one level is present in selectedLevel
      const hasValidLevel = item?.level?.some((level: any) => {
        return Object.keys(selectedLevel)?.includes(level);
      });
      return !hasValidLevel; // If no valid level found, return true (invalid), else false (valid)
    });
    if (isInvalidLevel) {
      showToast(t("GENERAL.REMOVE_ADD_QUESTION_INFO_MSG"), "info");
    } else {
      if (skillCardRef.current) {
        skillCardRef.current.addSkill();
        setSearchKeywordTerm("");
        removeFromQueryParams(queryParams, "skillSideBar", navigate);
        removeFromQueryParams(queryParams, "skId", navigate);
      }
    }
  };

  useEffect(() => {
    const currentSkillId = isAddedSKillPopupOpen?.popupData?.skillId;
    if (currentSkillId) {
      getSkillKeywordsApi(
        currentSkillId,
        selectedLevel,
        searchKeywordTermDebounce,
      );
    } else {
      setKeywordSuggestions([]);
    }
  }, [isAddedSKillPopupOpen, searchKeywordTermDebounce, keywordsCurrentPage]);
  const handleTypeSelectChange = (level: string, value: number) => {
    setSelectedLevel?.((prev: any) => {
      const updated = { ...prev };
      if (value === 0) {
        delete updated[level]; // Remove the level if value is 0
      } else {
        updated[level] = value; // Add/update the level if value is non-zero
      }
      return updated;
    });
  };
  const handleAddSuggestion = (item: any) => {
    const priorityOrder = ["Expert", "Intermediate", "Beginner"];
    // If any level in selectedLevel matches item.level
    if (
      Object.keys(selectedLevel).some((level) => item?.level.includes(level))
    ) {
      if (searchSuggestionRef.current) {
        searchSuggestionRef.current.addSuggestion(item);
      }
    } else {
      // Find the highest priority level from item.level
      const selectedByPriority = priorityOrder.find((level) =>
        item.level.includes(level),
      );

      if (selectedByPriority) {
        handleTypeSelectChange(selectedByPriority, 1);
      }

      if (searchSuggestionRef.current) {
        searchSuggestionRef.current.addSuggestion(item);
      }
    }
  };

  const handleRequestNewItem = async (
    requestType: string,
    requestInput: string,
    meta: any,
  ) => {
    try {
      const supportTye = await getAllSupportType();
      if (supportTye?.data?.status === 200) {
        // only take id of bug type
        const reportBugObj = (supportTye?.data?.data?.data || [])
          .map((item: any) => ({
            value: item?.supportTicketTypeId,
            label: item?.supportTicketTypeName,
          }))
          .filter((item: any) => item.label === "Request");
        postNewSkillKeyword(
          requestType,
          capitalizeFirstLetter(requestInput),
          reportBugObj[0]?.value,
          meta,
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  const postNewSkillKeyword = async (
    subject: string,
    description: string,
    supportTicketTypeId: string,
    meta: any,
  ) => {
    if (subject === "skill") {
      setRequestNewItemLoading({ skillLoadig: true, keywordLoading: false });
    } else {
      setRequestNewItemLoading({ skillLoadig: false, keywordLoading: true });
    }
    const userId = localStorage.getItem("companyUserId");
    try {
      const res = await createSupportTicket({
        supportTicketTypeId, //request id
        userId,
        assignId: null,
        userType: "COMPANY_ADMIN",
        status: "NEW",
        subject,
        description,
        attachmentUrls: [],
        meta,
      });
      if (res?.status === 200) {
        showToast(t("GENERAL.REQUEST_SENT"), "success");
      }
      if (subject === "skill") {
        setRequestSkillInput("");
        setRequestNewItemLoading({ skillLoadig: false, keywordLoading: false });
      } else {
        setRequestNewKeyword(false);
        setRequestKeywordInput("");
        setRequestNewItemLoading({ skillLoadig: false, keywordLoading: false });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="createBuildSec">
      <div className="">
        <div className="row">
          <div className="langSelectSec">
            <div className="dropFilterLeft"></div>
            <div className="scrollArea" ref={scrollAddedSkillRef}>
              <div className="langSelect" ref={selectedSkillRef}>
                {addedSkills?.map((item: any, ind: number) => {
                  const skillTime = calculatTotalTimeOfSkill(
                    item?.questionType,
                    item?.questionNo,
                  );
                  return (
                    <div key={ind} className="forModelLang">
                      <div
                        className="langContent"
                        onClick={() => {
                          setAddedKeywordsList(
                            modifyKeywordsDataOnEdit(item?.skillKeywords) ?? [],
                          );
                          handlePopupOpen(
                            item?.skillId,
                            item,
                            setIsAddedSKillPopupOpen,
                            setSelectedLevel,
                            navigate,
                            queryParams,
                          );
                        }}
                        key={ind}
                      >
                        <div className="skillTime">
                          <span className="timeValue">
                            {Number.isNaN(skillTime) ? "-" : skillTime}
                          </span>
                          <span className="minutesText">
                            {t("GENERAL.MINS")}
                          </span>
                        </div>
                        <div className="skillNameType">
                          <div className="langName">
                            {item?.skillName ?? item?.title} -{" "}
                            {item?.questionType}
                          </div>
                        </div>
                      </div>
                      <span
                        onClick={() => {
                          handleRemoveSkill(item?.id);
                        }}
                        className="crossBtn"
                      >
                        <TestCaseWrongIcon />
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            {addedSkills?.length && elementWidth + 25 > width ? (
              <div className="scroll-Controllers">
                <div
                  onClick={() => {
                    handleScroll("prev", scrollAddedSkillRef);
                  }}
                >
                  <PreviousArrow color={"var(--primary-green)"} />
                </div>
                <div
                  onClick={() => {
                    handleScroll("next", scrollAddedSkillRef);
                  }}
                >
                  <NextArrow color={"var(--primary-green)"} />
                </div>
              </div>
            ) : null}
            <div className="dropFilterRight"></div>
          </div>
          <div className="col-md-3 marginTop">
            <div className="categorySideBar">
              <div className="categorySearch">
                <TemplateSearch
                  onChange={(e) => {
                    setGlobalSearch(e);
                    if (e?.trim()?.length) {
                      setCategoryCurrentPage(1);
                      setSkillCardLoader(true);
                      setSkill([]);
                    } else {
                      setCategoryCurrentPage(1);
                      setSkill([]);
                    }
                  }}
                  placeholder={t("CREATE_ASSESSMENT.SKILL_SEARCH_PLACEHOLDER")}
                  value={globalSearch}
                  handleKeyPress={() => {}}
                  isCrossIconVisible={(globalSearch && true) || false}
                  onCrossPress={() => {
                    setGlobalSearch("");
                    if (globalSearch?.trim()?.length) {
                      setSkillCardLoader(true);
                      setSkill([]);
                    }
                  }}
                />
              </div>
              <div
                onClick={() => handleReset()}
                className={
                  selectedCategory?.length ||
                  selectedFilter?.length ||
                  globalSearch?.length
                    ? "categoryResetBtn"
                    : "categoryResetBtn pointerEventsResetBtn"
                }
              >
                {t("GENERAL.RESET")}
              </div>
              <div className="categoryAccord">
                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        {t("CREATE_ASSESSMENT.GLOBAL_CATEGORY")}
                        <span>
                          <DownArrow />
                        </span>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body">
                        {category?.map((list: any, key: number) => (
                          <div
                            key={key}
                            className="technicalSec"
                            onClick={() => {
                              handleCheckboxChange(list?.id);
                            }}
                          >
                            <AssessmentCheckboxRadio
                              type="checkbox"
                              checked={list?.selected}
                            />
                            <label>
                              {list?.categoryName}
                              <span className="skillCount">
                                {list?.skillCount}
                              </span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        onClick={() =>
                          setRequestNewSkillPopup(!requestNewSkillPopup)
                        }
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseThree"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseThree"
                      >
                        {t("GENERAL.REQUEST_NEW_SKILL")}
                        <span className="addIcon">
                          <AddIcon />
                        </span>
                      </button>
                    </h2>
                    <div className="pb-3">
                      {requestNewSkillPopup && (
                        <div className="requestKeywordSec">
                          <div className="position-relative">
                            <InputField
                              placeholder={t("GENERAL.ENTER_SKILL_NAME")}
                              additionalProps={{ className: "skillNameInput" }}
                              value={requestSkillInput}
                              onChange={(value: any) => {
                                setShowSkillsSuggestions(true);
                                setRequestSkillInput(value);
                                !value && setExistingSkillsSuggestions([]);
                              }}
                            />
                            {showSkillsSuggestion &&
                            existingSkillsSuggestions?.length ? (
                              <div className="existingSkillsSuggestionSection">
                                {existingSkillsSuggestions.map(
                                  (item: any, index: any) => (
                                    <div key={index} className="list-item">
                                      <span
                                        onClick={() => {
                                          setRequestSkillInput(item.skillName);
                                          setShowSkillsSuggestions(false);
                                        }}
                                        className="list-text"
                                      >
                                        {item.skillName}
                                      </span>
                                      {index !== item.length - 1 && (
                                        <div className="divider"></div>
                                      )}
                                    </div>
                                  ),
                                )}
                              </div>
                            ) : null}
                          </div>
                          <AssessmentButton
                            disabled={
                              !requestSkillInput.trim() ||
                              requestNewItemLoading.skillLoadig
                            }
                            onClick={() => {
                              handleRequestNewItem(
                                "skill",
                                requestSkillInput,
                                {},
                              );
                            }}
                          >
                            {t("GENERAL.SUBMIT")}
                            {requestNewItemLoading.skillLoadig && <Loader />}
                          </AssessmentButton>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-9">
            <div className="usageAZFilters">
              {/* question type filter */}
              <div className="common usageBtnSec">
                <p>{t("CREATE_ASSESSMENT.QUESTION_TYPE")} : </p>
                <div className="d-flex gap-4">
                  {questionTypeCategory?.map((list: any, key: number) => (
                    <div
                      key={key}
                      className=" d-flex align-items-center"
                      onClick={() => handlequestionTypeChange(list?.id)}
                    >
                      <AssessmentCheckboxRadio
                        type="checkbox"
                        checked={list?.selected}
                      />
                      <label className="questionTypeLabel">
                        {list?.questionType}
                        <span className="skillCount">{list?.skillCount}</span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-flex gap-3 usageBtnSection">
                <div className="common usageBtnSec">
                  <p>{t("CREATED_ASSESSMENT_USAGE")}</p>
                  <div
                    className="arrowIcon"
                    onClick={() => handleSortBy("Usage")}
                  >
                    {sortBy?.usage?.sort === "ASC" ? (
                      <DownArrowIcon isDisable={true} />
                    ) : (
                      <UpArrowIcon isDisable={true} />
                    )}
                  </div>
                </div>
                <div className=" common azBtnSec">
                  <p>{t("CREATED_ASSESSMENT_A_Z")}</p>
                  <div className="arrowIcon" onClick={() => handleSortBy("AZ")}>
                    {sortBy?.aToZ?.sort === "ASC" ? (
                      <DownArrowIcon isDisable={true} />
                    ) : (
                      <UpArrowIcon isDisable={true} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`addingLangSection ${skillCardLoader && "bgWhite"}`}
            >
              <div className="row">
                {skillCardLoader ? (
                  <div className="skillCardSkeleton">
                    <div className="skillCardLoading">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index}>
                          <SkeletonList
                            key={index}
                            numberOfTitles={1}
                            numberofTextLines={1}
                            titleSize={10}
                            textSize={6}
                            thumbnailHeight={70}
                            thumbnailWidth={70}
                            itemsGap={10}
                            contentDetailsPosition="end"
                          />
                        </div>
                      ))}
                    </div>

                    <div className="skillCardLoading">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index}>
                          <SkeletonList
                            key={index}
                            numberOfTitles={1}
                            numberofTextLines={1}
                            titleSize={10}
                            textSize={6}
                            thumbnailHeight={70}
                            thumbnailWidth={70}
                            itemsGap={10}
                            contentDetailsPosition="end"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : skill?.length > 0 ? (
                  <>
                    {skill.map((item: any, ind: number) => (
                      <div
                        key={ind}
                        className="col-sm-12 col-md-6 col-lg-4 skillCardsGrid"
                      >
                        <SkillCard
                          addedSkills={addedSkills}
                          setIsAddedSKillPopupOpen={setIsAddedSKillPopupOpen}
                          skillItem={item}
                          textBtn={t("GENERAL.ADD")}
                          handleAddSkill={handleAddSkill}
                          isAdded={addedSkills.some(
                            (skill: any) => skill?.skillId === item?.skillId,
                          )}
                          setSelectedLevel={setSelectedLevel}
                          setAddedKeywordsList={setAddedKeywordsList}
                          showIcon={false}
                        />
                      </div>
                    ))}

                    {/* Load More Button */}
                    {hasMore && (
                      <div className="loadMore mt-3">
                        <AssessmentButton
                          onClick={loadMore}
                          disabled={!hasMore}
                        >
                          {t("GENERAL.LOAD_MORE")}
                        </AssessmentButton>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="noDataAvailabel">
                    <div className="requestNewSkill">
                      <h1>{t("GENERAL.NO_SKILLS_FOUND")}</h1>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAddedSKillPopupOpen?.isPopupOpen && (
        <RightSidePanel
          show={isAddedSKillPopupOpen?.isPopupOpen}
          handleClose={() => {
            setIsAddedSKillPopupOpen({ isPopupOpen: false, popupData: {} });
            setSearchKeywordTerm("");
            setKeywordSuggestions([]);
            setRequestNewKeyword(false);
            setKeywordsCurrentPage(1);
            setLoadingSuggestions(true);
            removeFromQueryParams(queryParams, "skillSideBar", navigate);
            removeFromQueryParams(queryParams, "skId", navigate);
          }}
          title={t("GENERAL.SKILL")}
          className="rightSidePanelSection "
        >
          <div className="updateSkillData">
            <SkillCard
              ref={skillCardRef}
              skillItem={isAddedSKillPopupOpen?.popupData}
              handleAddSkill={handleAddedSkill}
              textBtn={t("GENERAL.UPDATE")}
              hideButton={true}
              skillKeywords={addedKeywordsList}
              setSelectedLevel={setSelectedLevel}
              selectedLevel={selectedLevel}
            />
            <div className="addKeywordsSection">
              <div className="stickKeyHead">
                <h3 className="addKeywordsText">
                  {t("RESUME.SCANNING_ADD_KEYWORDS")}
                  <span className="optionalText">
                    ({t("GENERAL.OPTIONAL")})
                  </span>
                </h3>
                <SearchSuggestion
                  onKeywordSearchCrossClick={() => {
                    setLoadingSuggestions(true);
                    setKeywordSuggestions([]);
                    setRequestNewKeyword(false);
                    setSearchKeywordTerm("");
                    setKeywordsCurrentPage(1);
                    getSkillKeywordsApi(
                      isAddedSKillPopupOpen.popupData.skillId,
                      selectedLevel,
                      "",
                    );
                  }}
                  searchTerm={searchKeywordTerm}
                  onChange={(e: string) => {
                    setSearchKeywordTerm(e);
                    setKeywordsCurrentPage(1);
                    if (e.length == 0) {
                      setLoadingSuggestions(true);
                      setKeywordSuggestions([]);
                      setRequestNewKeyword(false);
                      getSkillKeywordsApi(
                        isAddedSKillPopupOpen.popupData.skillId,
                        selectedLevel,
                        "",
                      );
                    }
                  }}
                  onAddSuggestionClick={onAddSuggestionClick}
                  addedKeywordsList={addedKeywordsList}
                  ref={searchSuggestionRef}
                />
                <div className="sarchedKeyword mt-3">
                  {addedKeywordsList
                    ?.reduce((acc: any, item: any) => {
                      if (!acc.includes(item?.keywords?.toLowerCase()))
                        acc.push({
                          keywordName: item?.keywords?.toLowerCase(),
                          level: item?.level,
                        });
                      return acc;
                    }, [])
                    .map((keyword: any, ind: any) => {
                      return (
                        <div
                          key={ind}
                          className={`word ${
                            keyword?.level?.some((level: any) =>
                              Object.keys(selectedLevel).includes(level),
                            )
                              ? ""
                              : "disableGrey"
                          }`}
                        >
                          <span>{keyword?.keywordName}</span>
                          <div
                            onClick={() =>
                              handleDeleteAddedKeyword(keyword?.keywordName)
                            }
                            className="deleteKeyword"
                          >
                            <CircleCrossIcon
                              color="var(--primary-white)"
                              width="16px"
                              height="16px"
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {loadingSuggestions ? (
                <div className="d-flex justify-content-center mt-5">
                  <Loader />
                </div>
              ) : (
                <div>
                  {keywordSuggestions.length > 0 ? (
                    <div ref={keywordsListRef} className="keywordsListSection">
                      <ul className="suggestionsList">
                        {keywordSuggestions?.map((item: any, index: number) => {
                          const isSkillPresent = addedKeywordsList?.some(
                            (keyword: any) => {
                              return (
                                keyword?.skillId === item?.skillId &&
                                keyword?.keywords?.toLowerCase() ===
                                  item?.keywords?.toLowerCase() &&
                                keyword?.level?.some((level: any) =>
                                  item?.level.includes(level),
                                )
                              );
                            },
                          );
                          return (
                            <li key={index} className="suggestionItem">
                              <span className="suggestionText">
                                {capitalizeFirstLetter(item?.keywords)}
                              </span>
                              {isSkillPresent ? (
                                <AssessmentButton
                                  className={"addButton addedBtn"}
                                >
                                  {t("GENERAL.ADDED")}
                                </AssessmentButton>
                              ) : (
                                <AssessmentButton
                                  onClick={() => handleAddSuggestion(item)}
                                  className={"lightBtn addButton"}
                                >
                                  {t("GENERAL.ADD")}
                                </AssessmentButton>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                      {keywordsCurrentPage <
                        Math.ceil(keywordsCount / keywordsPageSize) &&
                        keywordDownLoader && (
                          <div className="d-flex justify-content-center mt-3">
                            <Loader />
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="keywordNotFound">
                      <span>{t("GENERAL.NO_KEYWORD_FOUND")}</span>
                      {!requestNewKeyword ? (
                        <AssessmentButton
                          onClick={() => setRequestNewKeyword(true)}
                        >
                          {t("GENERAL.REQUEST_NEW_KEYWORD")}
                        </AssessmentButton>
                      ) : (
                        <div className="requestKeywordSec">
                          <InputField
                            placeholder={t("GENERAL.ENTER_KEYWORD")}
                            additionalProps={{ className: "skillNameInput" }}
                            value={requestKeywordInput}
                            onChange={(value: any) => {
                              setRequestKeywordInput(value);
                            }}
                          />
                          <AssessmentButton
                            onClick={() => {
                              handleRequestNewItem(
                                "keyword",
                                requestKeywordInput,
                                {
                                  skillId:
                                    isAddedSKillPopupOpen?.popupData?.skillId,
                                  difficultyLevel: Object.keys(selectedLevel),
                                },
                              );
                            }}
                            disabled={
                              !requestKeywordInput ||
                              requestNewItemLoading.keywordLoading
                            }
                          >
                            {t("GENERAL.SUBMIT")}
                            {requestNewItemLoading.keywordLoading && <Loader />}
                          </AssessmentButton>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="sidePanelBtn">
              {addedKeywordsList.length ? (
                <div>
                  <span>
                    {t("GENERAL.ADDED_KEYWORDS")} : {addedKeywordsList.length}
                  </span>
                </div>
              ) : null}
              <AssessmentButton
                className={"lightBtn"}
                onClick={handleSaveBtnClick}
              >
                {Object.keys(
                  isAddedSKillPopupOpen?.popupData?.selectedDifficultyLevels,
                )?.length > 0
                  ? t("GENERAL.UPDATE")
                  : t("GENERAL.ADD")}
              </AssessmentButton>
            </div>
          </div>
        </RightSidePanel>
      )}
    </div>
  );
};

export default SidebarCategory;
